<template>
	<v-dialog
		persistent
		max-width="900"
		v-model="dialog"
		scrollable
	>
		<v-card v-if="legendUrl">
			<v-card-title>
				<span>Sluoksnio legenda</span>
			</v-card-title>
			<v-card-text>
				<img v-bind:src="legendUrl">
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		data: function(){
			var data = {
				dialog: false,
				legendUrl: null
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-legend-dialog", this.showDialog);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-legend-dialog", this.showDialog);
		},
		methods: {
			closeDialog: function(){
				this.legendUrl = null;
				this.dialog = false;
			},
			showDialog: function(legendUrl){
				console.log("SHOW DIALOG", legendUrl);
				this.legendUrl = legendUrl;
				this.dialog = true;
			}
		}
	}
</script>

<style scoped>
	img {
		max-width: 100%;
	}
</style>